export const APP_CONFIG = {
  frontendPort: 8713,
  backendPort: 8712,
  apiPrefix: '/api',
  requestTimeout: 30000,
};

export const API_BASE_URL = `${APP_CONFIG.apiPrefix}`;
